import { type MachinePublic } from "@aura-frontend/omnibus-az-client";
import { Trash } from "lucide-react";

import { Button } from "../ui/Button";
import { Spinner } from "../ui/spinner";

interface SelectedMachinesListProps {
  selectedMachines: MachinePublic[];
  isLoading: boolean;
  onRemoveMachine: (machineId: string) => void;
  isPending: boolean;
}

export function SelectedMachinesList({
  selectedMachines,
  isLoading,
  onRemoveMachine,
  isPending,
}: SelectedMachinesListProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-4">
        <Spinner className="h-6 w-6" />
      </div>
    );
  }

  if (!selectedMachines || selectedMachines.length === 0) {
    return null;
  }

  return (
    <div className="mt-2 flex flex-col gap-2">
      {selectedMachines.map((machine) => (
        <div key={machine.machineUuid} className="flex gap-2 items-center">
          <p className="px-3 py-2.5 bg-white rounded-md w-full text-sm">
            {machine.name}
          </p>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onRemoveMachine(machine.machineUuid)}
            disabled={isPending}
            type="button"
          >
            {isPending ? <Spinner className="h-4 w-4" /> : <Trash />}
          </Button>
        </div>
      ))}
    </div>
  );
}
